'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getBlob = exports.getBlob = function getBlob(bytes) {
    return new Blob([bytes], { type: 'application/pdf', length: bytes.length });
};

var isMsDownloadRequired = exports.isMsDownloadRequired = function isMsDownloadRequired() {
    return window.navigator.msSaveOrOpenBlob;
};

var msDownload = exports.msDownload = function msDownload(bytes, title) {
    window.navigator.msSaveOrOpenBlob(getBlob(bytes), title);
};
//# sourceMappingURL=helper.js.map